<template>
  <section>
    <div class="container is-widescreen">
      <h4 class="title is-size-4 has-text-primary" v-t="'news_and_agenda'"></h4>
      <div v-if="feeds" class="columns is-hidden-mobile is-variable is-1" style="padding-top:15px">
        <div class="column" v-for="(feed,index) in parsedFeed" :key="index">
          <AppRSSFeed :feed="feed"/>
        </div>
      </div>
      <carousel
        v-if="feeds"
        class="is-hidden-tablet"
        paginationColor="grey"
        :perPage="1"
        :paginationEnabled="true"
        :navigationEnabled="false"
        :autoplay="true"
        :autoplayTimeout="10000"
        :loop="true"
      >
        <slide v-for="(feed,index) in parsedFeed" :key="index">
          <AppRSSFeed :feed="feed" class="column"/>
        </slide>
      </carousel>
    </div>
  </section>
</template>

<script>
import AppRSSFeed from './AppRSSFeed'
import { Carousel, Slide } from 'vue-carousel'
import { mapGetters } from 'vuex'
import axios from 'axios'
import xml2js from 'xml2js'
import _ from 'underscore'
export default {
  components: {
    AppRSSFeed,
    Carousel,
    Slide
  },
  mounted () {
    axios
      .get(`feed/${this.$store.getters.activeLanguage}`)
      .then(rslt => {
        var parser = new xml2js.Parser({
          trim: false,
          normalize: true,
          mergeAttrs: true
        })
        parser.addListener('error', function (err) {
          console.log('error parsing')
          throw err
        })
        parser.parseString(rslt.data, (err, result) => {
          if (err) throw err
          this.feeds = result
        })
      })
      .catch((this.feeds = null))
  },

  computed: {
    ...mapGetters(['activeLanguage']),
    parsedFeed: function () {
      return _.first(this.parser(this.feeds).items, 3)
    }
  },
  methods: {
    parser: function (json) {
      if (!json.rss) return []
      var channel = json.rss.channel
      var rss = { items: [] }
      if (_.isArray(json.rss.channel)) channel = json.rss.channel[0]

      if (channel.title) {
        rss.title = channel.title[0]
      }
      if (channel.description) {
        rss.description = channel.description[0]
      }
      if (channel.link) {
        rss.url = channel.link[0]
      }

      // add rss.image via @dubyajaysmith
      if (channel.image) {
        rss.image = channel.image[0].url
      }

      if (!rss.image && channel['itunes:image']) {
        rss.image = channel['itunes:image'][0].href
      }

      rss.image = rss.image && Array.isArray(rss.image) ? rss.image[0] : ''

      if (channel.item) {
        if (!_.isArray(channel.item)) {
          channel.item = [channel.item]
        }
        channel.item.forEach(function (val) {
          var obj = {}
          obj.title = !_.isNull(val.title) ? val.title[0] : ''
          obj.description = !_.isNull(val.description)
            ? val.description[0]
            : ''
          obj.url = obj.link = !_.isNull(val.link) ? val.link[0] : ''

          if (val['itunes:subtitle']) {
            obj.itunes_subtitle = val['itunes:subtitle'][0]
          }
          if (val['itunes:summary']) {
            obj.itunes_summary = val['itunes:summary'][0]
          }
          if (val['itunes:author']) {
            obj.itunes_author = val['itunes:author'][0]
          }
          if (val['itunes:explicit']) {
            obj.itunes_explicit = val['itunes:explicit'][0]
          }
          if (val['itunes:duration']) {
            obj.itunes_duration = val['itunes:duration'][0]
          }
          if (val['itunes:season']) {
            obj.itunes_season = val['itunes:season'][0]
          }
          if (val['itunes:episode']) {
            obj.itunes_episode = val['itunes:episode'][0]
          }
          if (val['itunes:episodeType']) {
            obj.itunes_episodeType = val['itunes:episodeType'][0]
          }
          if (val.pubDate) {
            // lets try basis js date parsing for now
            obj.created = Date.parse(val.pubDate[0])
          }
          if (val['media:content']) {
            obj.media = val.media || {}
            obj.media.content = val['media:content']
          }
          if (val['media:thumbnail']) {
            obj.media = val.media || {}
            obj.media.thumbnail = val['media:thumbnail']
          }
          if (val.enclosure) {
            obj.enclosures = []
            if (!_.isArray(val.enclosure)) val.enclosure = [val.enclosure]
            val.enclosure.forEach(function (enclosure) {
              var enc = {}
              for (var x in enclosure) {
                enc[x] = enclosure[x][0]
              }
              obj.enclosures.push(enc)
            })
          }
          new xml2js.Parser({
            trim: false,
            normalize: true,
            mergeAttrs: true
          }).parseString(obj.description, (err, result) => {
            if (err) throw err
            obj.media = result.div.img
          })
          rss.items.push(obj)
        })
      }
      return rss
    }
  },
  data () {
    return {
      feeds: null
    }
  }
}
</script>

<style>
</style>
